export default "__VITE_ASSET__BYTZ9KwV__"